export default __webpack_public_path__ + "static/media/i-download.a8aeb190.svg";